module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Tenders":"Tenders","Clients":"Clients","Users":"Users","Ongoing":"Ongoing","Active":"Active","Inactive":"Inactive","Pending":"Pending"},"al":{"Tenders":"Tenderat","Clients":"Klientët","Users":"Përdoruesit","Ongoing":"Në vazhdim","Active":"Aktiv","Inactive":"Jo Aktiv","Pending":"Në Pritje"}}')
  delete Component.options._Ctor
}
